import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  Validators,
  ValidationErrors
} from '@angular/forms';
import { TdLoadingService, TdDialogService } from '@covalent/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-old-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class OldProfileComponent implements OnInit, OnDestroy {
  /**
   * Session data
   */
  sessionData: { [key: string]: any };

  /**
   * Profile form
   */
  profileForm: FormGroup;

  hrefUrl: string;
  checkUrl: string;
  interval: any;

  /**
   * Subscriptions
   */
  private _subs: Set<Subscription> = new Set();

  /**
   * Construction
   *
   * @param _fb
   * @param _http
   * @param _router
   * @param _activatedRoute
   * @param _viewContainerRef
   * @param _loadingService
   * @param _dialogService
   */
  constructor(
    private _fb: FormBuilder,
    private _http: HttpClient,
    private _authService: AuthService,
    private _activatedRoute: ActivatedRoute,
    private _viewContainerRef: ViewContainerRef,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService
  ) {
    this.profileForm = _fb.group({
      pid: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      // livingPlace: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: [''],
      passwordConfirmation: ['']
    });
  }

  /**
   * Init
   */
  ngOnInit() {
    this.getMeta();
    this._subs.add(
      this._activatedRoute.data.subscribe((data) => {
        this.sessionData = data['sessionData'];
        this.profileForm.patchValue(data['sessionData']);
      })
    );

    this._subs.add(
      // Subscribe to password control value change
      // to set password confirmation control validators
      this.profileForm.controls['password'].valueChanges.subscribe((value) => {
        const control = this.profileForm.controls['passwordConfirmation'];
        if (value) {
          control.setValidators(
            Validators.compose([
              Validators.required,
              Validators.minLength(6),
              this.samePassword
            ])
          );
        } else {
          control.setValue('');
          control.clearValidators();
          control.markAsPristine();
          control.markAsUntouched();
        }
      })
    );
  }

  /**
   * Destroy
   */
  ngOnDestroy() {
    this._subs.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Opens alert dialog
   *
   * @param message
   * @param title
   */
  private _openAlert(message: string, title: string = '') {
    return this._dialogService.openAlert({
      message: message,
      viewContainerRef: this._viewContainerRef, //OPTIONAL
      title: title, //OPTIONAL, hides if not provided
      closeButton: 'დახურვა', //OPTIONAL, defaults to 'CLOSE'
      width: '400px' //OPTIONAL, defaults to 400px
    });
  }

  /**
   * Password confirmation validator
   *
   * @param control
   */
  samePassword(control: AbstractControl): ValidationErrors | null {
    if (!control || !control.parent) {
      return null;
    }

    if (control.value !== control.parent.get('password').value) {
      return { passwordMismatch: true };
    }

    return null;
  }

  /**
   *
   */
  get style() {
    return {};
  }

  /**
   *
   * @param event
   */
  saveProfile(event: Event) {
    if (this.profileForm.valid) {
      const { phone, password } = this.profileForm.value;

      const observables$ = [];

      observables$.push(
        this._http.post('/api/idea/user/edit', { data: { phone } })
      );

      if (password) {
        observables$.push(
          this._http.post('/api/idea/user/password/edit', {
            data: { password }
          })
        );
      }

      this._loadingService.register();
      Observable.zip(...observables$)
        .finally(() => {
          this._loadingService.resolve();
        })
        .subscribe((res) => {
          this._openAlert('თქვენი ცვლილებები წარმატებით შეინახა')
            .afterClosed()
            .subscribe(() => location.reload());
        });
    }
  }

  getMeta() {
    this._http.post('/api/auth/id/meta', {}).subscribe((res) => {
      this.hrefUrl = res['hrefUrl'];
      this.checkUrl = res['checkUrl'];
    });
  }

  idVerify() {
    window.open(this.hrefUrl);
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.interval = setInterval(() => {
      this._http.get(this.checkUrl).subscribe((res: any) => {
        if (res.result.data && res.result.data.status) {
          clearInterval(this.interval);
          this.interval = null;
          this._http
            .post('/api/auth/set/verified', {
              verified: true,
              idCardFullName: res.result.data.fullName,
              pid: res.result.data.privateNumber
            })
            .subscribe((resp: any) => {
              this._authService._setSessionData(resp.result.data);
              location.reload();
            });
        }
      });
    }, 3000);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/old-profile/profile.component.ts